import { Instance } from 'mobx-state-tree';
import { UserLegacyMetadataDtoModelBase } from './UserLegacyMetadataDtoModel.base';

/* The TypeScript type of an instance of UserLegacyMetadataDtoModel */
export interface UserLegacyMetadataDtoModelType extends Instance<typeof UserLegacyMetadataDtoModel.Type> {}

/* A graphql query fragment builders for UserLegacyMetadataDtoModel */
export { selectFromUserLegacyMetadataDto, userLegacyMetadataDtoModelPrimitives, UserLegacyMetadataDtoModelSelector } from './UserLegacyMetadataDtoModel.base';

/**
 * UserLegacyMetadataDtoModel
 */
export const UserLegacyMetadataDtoModel = UserLegacyMetadataDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
